import * as React from 'react';
import './avatar.scss';

export const Avatar = props => {
    const { src, icon, size, shape, border } = props;

    const className = () => {
        return `avatar ${size} ${shape} ${border && 'border'}`;
    };

    return <img src={src || icon} className={className()} />;
};

Avatar.defaultProps = {
    shape: 'circle',
    size: 'default',
    icon: 'https://cutt.ly/GeowOzl'
};
export default Avatar;
